import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { useState, useEffect } from "react";
import { fetchRatings } from "../slice/ratingSlice";
import { createTVShow } from "../slice/tvShowSlice";
import { createTVShowListItem } from "../slice/tvShowListItemsSlice";

const TMDBTVShow = ({ tmdbTVShow }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { sid } = useParams();
  const [isShowSelected, setIsShowSelected] = useState(false);
  const [dateWatched, setDateWatched] = useState("");
  const [ratings, setRatings] = useState([]);
  const [rating, setRating] = useState({});
  const [ratingId, setRatingId] = useState(-1);

  const reduxRatings = useSelector((state) => state.ratings.ratings);

  useEffect(() => {
    if (reduxRatings !== undefined && reduxRatings.length > 0) {
      setRatings(reduxRatings);
    }
  }, [reduxRatings]);

  // tv show
  const { tvShows, isLoading } = useSelector((state) => {
    return state?.tvShows;
  });

  const actors = () => {
    return tmdbTVShow?.actors?.map((actor) => `${actor?.name}`).join(", ");
  };

  useEffect(() => {
    dispatch(fetchRatings());
  }, [dispatch]);

  const handleRatingSelected = (event) => {
    const value = event.target.value;
    console.log("handleRatingSelected value ", value);
    const rating = parseInt(value, 10); // convert to integer in base 10
    const selectedRating = ratings.find((r) => r.value === rating);
    console.log("selected rating ", selectedRating);
    setRatingId(rating);
    setRating(selectedRating);
  };

  const handleSelect = () => {
    console.log("selected!");
    setIsShowSelected(true);
  };

  const genres = () => {
    console.log("!!! tvShowListItem: ", tmdbTVShow);
    return tmdbTVShow?.genres?.join(", ");
  };

  const handleSave = async (e) => {
    try {
      e.preventDefault();
      // user selected tv show, create a record of it on the backend
      const resultAction = await dispatch(createTVShow(tmdbTVShow));
      if (createTVShow.fulfilled.match(resultAction)) {
        console.log("got back tv show: ", resultAction);
        const tvShowSid = resultAction?.payload?.sid;
        const tvShowListItem = {
          listSid: sid,
          tvShowSid,
          dateStarted: dateWatched,
          rating,
        };

        // use newly created tv show to make tv show list item
        console.log("sending tvShowListItem: ", tvShowListItem);
        const listItemResponse = await dispatch(
          createTVShowListItem(tvShowListItem)
        );
        console.log("!!! listItemRespose ", listItemResponse);
        if (createTVShowListItem.fulfilled.match(listItemResponse)) {
          console.log("created tv show list item!");
          navigate(`/tvshows/${sid}/${listItemResponse?.payload?.sid}`);
        } else {
          console.log("failed to create tv show list item");
        }
      } else {
        console.log("failed to create tv show");
      }
    } catch (error) {
    } finally {
    }
  };

  const inputClasses =
    "w-full border border-stone-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-teal-600";

  return (
    <div
      className="card p-4 cursor-pointer hover:border-teal-600 max-w-md space-y-2"
      onClick={handleSelect}
    >
      <div className="font-medium text-stone-800">{tmdbTVShow?.title}</div>
      <div className="text-sm text-stone-500">{tmdbTVShow?.yearStart}</div>
      <div className="text-sm text-stone-800">{tmdbTVShow?.overview}</div>
      <div className="text-sm text-stone-500">
        {tmdbTVShow?.seasons} seasons &middot; {tmdbTVShow?.language}
      </div>
      <div className="text-sm text-stone-500">{genres()}</div>
      <div className="text-sm text-stone-500">{actors()}</div>
      {isShowSelected ? (
        <div
          className="space-y-3 pt-2 border-t border-stone-200"
          onClick={(e) => e.stopPropagation()}
        >
          <div>
            <label className="block text-sm font-medium text-stone-500 mb-1">
              Date watched
            </label>
            <Flatpickr
              className={inputClasses}
              value={dateWatched}
              onChange={(selectedDates) => setDateWatched(selectedDates[0])}
              options={{ dateFormat: "Y-m-d" }}
            />
          </div>
          <select
            id="dropdown"
            value={ratingId}
            onChange={handleRatingSelected}
            className={inputClasses}
          >
            <option value="-1" disabled>
              Rating
            </option>
            {reduxRatings.map((r) => (
              <option key={r.value} value={r.value}>
                {r.description}
              </option>
            ))}
          </select>
          <div className="flex justify-end">
            <button
              type="button"
              disabled={isLoading}
              onClick={handleSave}
              className="btn-primary"
            >
              {isLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default TMDBTVShow;
